"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
/**
 * Renders a user, formatted for use in the place page header
 * @param props
 */
function PlaceHeaderMetadataTableauUser(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: data_catalog_shared_1.placeHeaderMetadataLabelClass }, props.labelText),
        React.createElement(data_catalog_shared_1.UserLinkDisplayComponent, { user: props.tableauUser, linkComponent: PlaceHeaderUserLink })));
}
exports.PlaceHeaderMetadataTableauUser = PlaceHeaderMetadataTableauUser;
function PlaceHeaderUserLink(props) {
    return (React.createElement("a", { href: props.url, target: '_blank', className: data_catalog_shared_1.classes(data_catalog_shared_1.placeHeaderMetadataLinkClass, data_catalog_shared_1.placeHeaderMetadataValueClass), title: props.name }, props.name));
}
//# sourceMappingURL=PlaceHeaderMetadataTableauUser.js.map